import { AfterViewInit, Component, OnInit, inject, Input, ElementRef, ViewChild, EventEmitter, Output } from '@angular/core';
import { fromEvent } from 'rxjs';
import { map, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { MapService } from 'src/app/shared/services/map.service';
import { Aborter } from 'azure-maps-rest';

@Component({
  selector: 'app-location-search',
  templateUrl: './location-search.component.html',
  styleUrls: ['./location-search.component.scss']
})
export class LocationSearchComponent implements OnInit, AfterViewInit {
  private maps = inject(MapService);
  @Input() isServiceAreaSearch: boolean = false;
  @Input() fullAddress = "";
  @Input() careType = "";
  @Output() selectedPlace: EventEmitter<any> = new EventEmitter();
  @Output() ngModelChangeOfZipCode: EventEmitter<any> = new EventEmitter();
  @Output() submitSearch: EventEmitter<any> = new EventEmitter();

  public options = [] as Array<string>;
  private addrs?: GeoJSON.FeatureCollection<GeoJSON.Point>;
  @ViewChild("input", { static: true }) input!: ElementRef;
  ngOnInit() {
  }

  onChange(event: any) {
    const value = event.currentTarget.value;
    this.onSelectPlace(value);
  }

  onSelectPlace(value: string, isCheckZipCode?: boolean) {
    if (value && this.addrs && this.addrs.features) {
      const feats = this.addrs.features;
      for (let i = 0; i < feats.length; i++) {
        if (feats[i].properties && feats[i].properties!['address']) {
          if (feats[i].properties!['address'].freeformAddress && (feats[i].properties!['address'].freeformAddress.toLowerCase() == value.toLowerCase() || (isCheckZipCode && feats[i].properties!['address'].postalCode == value))) {
            let address = isCheckZipCode ? value : null;
            this.getFormattedAddress(feats[i], address);
            // this.selectedPlace.emit(this.maps.getFormattedAddress(feats[i], address));
            break;
          }
        }
      }
    }
  }

  getFormattedAddress(place: any, address?: string) {
    let county;
    const sendAddress = address ? address : place.properties?.address?.freeformAddress;
    if(sendAddress && !place.properties?.address?.countrySecondarySubdivision) {
      this.maps.getAddressDetails(sendAddress).subscribe((resp: any) => {
        county = resp.features[0].properties.address.adminDistricts[1] ? resp.features[0].properties.address.adminDistricts[1].shortName.replace(' Co.','') : '';
        this.selectedPlace.emit(this.maps.getLocationObject(place, county, address));
      });
    } else {
      county = place.properties?.address?.countrySecondarySubdivision;
      this.selectedPlace.emit(this.maps.getLocationObject(place, county, address));
    }
  }

  ngAfterViewInit() {
    fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        map((target: any) => target.currentTarget.value),
        debounceTime(350),
        distinctUntilChanged(),
        tap((event: string) => {
          this.ngModelChangeOfZipCode.emit(event);
          if (event.length > 0) {
            this.maps.searchFuzzy(event).then(
              (response: any) => {
                this.handleFuzzyResponse(response);
                this.addrs = response.geojson.getFeatures() as GeoJSON.FeatureCollection<GeoJSON.Point>;
                if (event && response && response.results && response.results.length > 0) {
                  this.onSelectPlace(event);
                }
              }
            );
            // this.maps.searchFuzzy(event).subscribe((resp: any) => {
            //   console.log(JSON.stringify(resp));
            // })
          }
        })
      )
      .subscribe();

    fromEvent(this.input.nativeElement, 'blur')
      .pipe(
        map((target: any) => target.currentTarget.value),
        debounceTime(350),
        distinctUntilChanged(),
        tap((event: string) => {
          if (event && /^\d+$/.test(event) && event.length >= 5) {
            this.onSelectPlace(event, true);
          }
        })
      )
      .subscribe();

    if (this.fullAddress) {
      this.maps.searchFuzzy(this.fullAddress).then(
        (response: any) => {
          this.handleFuzzyResponse(response);
          if (response && response.results && response.results[0].type == "Point Address") {
            this.addrs = response.geojson.getFeatures() as GeoJSON.FeatureCollection<GeoJSON.Point>;
            // this.addrs.features[0]
          }
        }
      );
    } else {
      this.fullAddress = "";
    }
  }

  onKeyEnter(event: any) {
    this.submitSearch.emit(event);
  }

  handleFuzzyResponse(response: any) {
    if (response && response.results) {
      const arr = [];
      for (let i = 0; i < response.results.length; i++) {
        var resp = response.results[i];
        var addr = resp.address;
        if (!arr.includes(addr?.freeformAddress)) {
          arr.push(`${addr?.freeformAddress}`);
        }
      }
      this.options = arr;
    }
  }

}
